import { useEffect, useState } from 'react';
import { api, ApiError } from '../../api';

// Bonus faizi (KT-96): şirkət üzrə susmaya görə; müştəri kartında öz faizi varsa o üstündür.
export function BonusSettingsPanel() {
  const [pct, setPct] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [notice, setNotice] = useState<string | null>(null);

  useEffect(() => {
    api
      .bonusSettings()
      .then((b) => setPct(String(b.pct)))
      .catch((err: unknown) => setError(err instanceof ApiError ? err.message : 'Bonus tənzimləməsi yüklənmədi'));
  }, []);

  const save = async () => {
    setBusy(true);
    setError(null);
    setNotice(null);
    try {
      const r = await api.bonusSettingsSave(Number(pct));
      setPct(String(r.pct));
      setNotice('Bonus faizi saxlanıldı.');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Saxlanmadı');
    } finally {
      setBusy(false);
    }
  };

  const n = Number(pct);
  const valid = pct !== '' && Number.isFinite(n) && n >= 0 && n <= 100;

  return (
    <section className="card" aria-label="Bonus faizi">
      <h2>Bonus</h2>
      <p className="muted small">Satışdan yığılan bonus faizi (bonusla ödənilən hissədən bonus yığılmır).</p>
      {error && (
        <p className="bad" role="alert">
          {error}
        </p>
      )}
      {notice && (
        <p className="ok" role="status">
          {notice}
        </p>
      )}
      <div className="role-new">
        <label className="field">
          Faiz (%)
          <input type="number" min="0" max="100" step="0.01" value={pct} onChange={(e) => setPct(e.target.value)} disabled={busy} />
        </label>
        <button type="button" className="btn-small" onClick={() => void save()} disabled={busy || !valid}>
          Bonus faizini saxla
        </button>
      </div>
    </section>
  );
}
